import React from 'react';
import CompactSelectPicker from '../ui/CompactSelectPicker';
import { LABEL_COLORS, labelColor, pillStyleVars } from '../../extensions/bundled/task-manager/boardLabels';
import './BoardLabelEditor.css';

const dot = (c) => <span className="board-label-dot" style={{ background: c.dot }} />;

const OPTIONS = LABEL_COLORS.map((c) => ({ value: c.key, label: c.name || c.key, leading: dot(c) }));

/**
 * A label's colour as a dropdown (Boards Redesign cards 5.2/5.3): the app's
 * CompactSelectPicker with a dot per colour, so it opens, flips and closes on
 * Escape like every other picker. The trigger shows only the colour —
 * `variant="swatch"` is the square swatch at the start of a palette row,
 * `variant="split"` the left half of the new-label input.
 */
export default function LabelColorPicker({ value, onChange, variant = 'swatch', 'aria-label': ariaLabel }) {
  const c = labelColor(value);
  return (
    <span className={`board-label-color-picker board-label-color-picker--${variant}`} style={pillStyleVars(c)}>
      <CompactSelectPicker
        value={c.key}
        onChange={onChange}
        options={OPTIONS}
        menuMinWidth={156}
        aria-label={ariaLabel || `Label colour: ${c.name || c.key}`}
      />
    </span>
  );
}
